export default __webpack_public_path__ + "static/media/cash.0a4d0bce.png";